import React from 'react';
import _ from 'lodash';
import ConvertibleControls from './ConvertibleControls';
import Frame from './Frame';
import Disclaimer from './Disclaimer';

const Profile = ({
  images,
  cgiDisclaimers,
  showConvertible,
  isConvertibleTopDown,
  style,
  onToggleTop
}) => {
  const url = _.get(_.find(images, x => x.profile), 'url');
  return (
    <div className="carousel" style={style}>
      <Disclaimer disclaimers={cgiDisclaimers} />
      <ConvertibleControls
        enabled={showConvertible}
        isTopDown={isConvertibleTopDown}
        analyticsKey="gallery:exterior"
        onToggle={onToggleTop}
      />
      <Frame url={url} />
    </div>
  );
};

export default Profile;
